export enum TrackingEvents {
  // API Deck Stuff
  IntegrationUploadAttempted = 'Integration Upload Attempted',
  IntegrationUploadSuccessful = 'Integration Upload Successful',
  IntegrationUploadUnsuccessful = 'Integration Upload Unsuccessful',
  IntegrationSelected = 'Integration Selected',

  // Chronology Updating
  UpdatedChronologyFactDate = 'Updated Chronology Fact Date',
  UpdateChronologyName = 'Update Chronology Name',
  AddFactToChronologyOnChronologyPage = 'Add Fact To Chronology On Chronology Page',
  RemoveFactFromChronology = 'Remove Fact From Chronology',
  DownloadChronologyTableCSV = 'Download Chronology Table CSV',
  DownloadChronologyTableDocx = 'Download Chronology Table Docx',
  DownloadChronologyWrittenDocx = 'Download Chronology Written Docx',
  DownloadChronologyWrittenCustomStyle = 'Download Chronology Written Custom Style',
  DeleteChronology = 'Delete Chronology',
  ClickViewChronology = 'Click View Chronology',
  UnverifyChronologyFact = 'Unverify Chronology Fact',
  VerifyChronologyFact = 'Verify Chronology Fact',
  DownloadChronologyWithDocuments = 'Download Chronology With Documents',

  // Sharing
  InvitedUserWithNoAccount = 'Invited User With No Account',
  AddUserToCaseFromCasePage = 'Add User To Case From Case Page',
  CopyCaseLink = 'Clicked Copy Case Link',
  TransferPersonalMatterCase = 'Transfer Personal Matter Case',
  RequestMatterAccess = 'Request Matter Access',

  // Case Uploading
  CaseUploaded = 'Case Uploaded',
  DeleteAllFiles = 'Delete All Files Clicked',
  UpdateCase = 'Update Case',
  CreateCase = 'Create Case',
  ViewCase = 'View Case',
  ViewDraftCase = 'View Draft Case',
  ViewCaseFromMatterSearchMatches = 'View Case From Matter Search Matches',
  DeleteCase = 'Delete Case',
  DeleteDraftCase = 'Delete Draft Case',
  GenerateCaseDetails = 'Generate Case Details',

  // Doc Viewer
  OpenDocViewerFromFact = 'Open Doc Viewer From Fact',
  OpenDocViewerFromKim = 'Open Doc Viewer From Kim',
  OpenDocViewerFromChronology = 'Open Doc Viewer From Chronology',
  OpenDocViewerFromInconsistency = 'Open Doc Viewer From Inconsistency',
  OpenInconsistencyDocComparer = 'Open Inconsistency Doc Comparer',
  ShowAllFactsInDocViewer = 'Show All Facts In Doc Viewer',
  DownloadDocumentInDocViewer = 'Download Document In Doc Viewer',
  FilterDocByTheme = 'Filter Document by Theme',

  // Full Doc Viewer Page
  AskKimFromDocViewer = 'Ask Kim From Doc Viewer',
  JumpToFactInDocFromDocFactsList = 'Jump To Fact In Doc From Doc Facts List',
  CreateFactFromDocViewer = 'Create Fact From Doc Viewer',
  SelectToCreateFactFromImageSelection = 'Select To Create Fact From Image Selection',
  ConfirmCreateFactFromImageSelection = 'Confirm Create Fact From Image Selection',

  // InconsistencyViewer
  OpenInconsistencyViewer = 'Open Inconsistency Viewer',

  // Kim
  AskedKimQuestion = 'Kim Question Asked',
  KimReferenceClicked = 'Kim Reference Clicked',
  ReferenceClicked = 'Reference Clicked',
  DownloadKimAnswer = 'Download Kim Answer',
  CopyKimAnswer = 'Copy Kim Answer',
  CopyKimPageLink = 'Copy Kim Page Link',
  KimConfidenceLevel = 'Kim Confidence Level Clicked',
  KimExampleQuestion = 'Kim Example Question Clicked',
  KimFollowUpQuestion = 'Kim Follow Up Question Clicked',
  KimTagDocument = 'Kim @ Document',
  KimExecutePlan = 'Kim Execute Plan',
  KimClickHelp = 'Kim Click Help',
  KimOnboardingClickQuestionFlow = 'Kim Onboarding Click Question Flow',
  KimOnboardingClickExtractionFlow = 'Kim Onboarding Click Extraction Flow',
  KimOnboardingClickDraftFlow = 'Kim Onboarding Click Draft Flow',
  KimOnboardingClickExampleQuestion = 'Kim Onboarding Click Example Question',
  KimOnboardingClickCustomQuestion = 'Kim Onboarding Click Custom Question',
  KimThreadPublished = 'Kim Thread Published',
  KimToggleThinking = 'Kim Toggle Thinking',
  KimUpdatePlan = 'Kim Update Plan',

  // Summary Page
  ViewKeyFactsFromSummary = 'View Key Facts From Summary',
  CopySummary = 'Copy Summary',
  CreateKeyFactsChronology = 'Create Key Facts Chronology',
  CreateRelevantFactsChronology = 'Create Relevant Facts Chronology',
  ViewCustomChronologyFromSummary = 'View Custom Chronology From Summary',
  ClickRelevantDocsOnSummary = 'Click Relevant Docs On Summary',
  OpenCaseSettings = 'Open Case Settings',
  // New summary page events
  AskKimFromSummaryCustom = 'Ask Kim From Summary Custom',
  AskKimFromSummaryDraft = 'Ask Kim From Summary Draft',
  AskKimFromSummaryQuestion = 'Ask Kim From Summary Question',
  ViewFullCaseIssuesOnSummary = 'View Full Case Issues On Summary',
  AddDocumentsOnSummary = 'Add Documents On Summary',
  ChangeIssuesOnSummary = 'Change Issues On Summary',
  ViewFullSummaryOnSummary = 'View Full Summary On Summary',
  ViewFullThemesOnSummary = 'View Full Themes On Summary',
  ViewAllDocsOnSummary = 'View All Docs On Summary',
  ViewAllEntitiesOnSummary = 'View All Entities On Summary',
  ViewAllInconsistenciesOnSummary = 'View All Inconsistencies On Summary',
  ViewIndividualInconsistencyOnSummary = 'View Individual Inconsistency On Summary',

  // Documents Page
  DownloadDocumentList = 'Download Document List',
  ApplyFiltersOnDocumentsPage = 'Apply Filters On Documents Page',
  ApplySortOnDocumentsPage = 'Apply Sort On Documents Page',
  UpdateDocumentName = 'Update Document Name',
  UpdateDocumentDate = 'Update Document Date',
  UpdateDocumentAuthor = 'Update Document Author',
  ClickViewDocument = 'Click View Document On Documents Page',
  ClickAddDocuments = 'Click Add Documents On Documents Page',
  NaturalLanguageSearchDocumentsWand = 'Natural Language Search Documents Wand',
  NaturalLanguageSearchDocumentsSpacebar = 'Natural Language Search Documents Spacebar',

  // Facts
  UpdateFactContent = 'Updated Fact Content',
  UpdateFactRelevance = 'Updated Fact Relevance',
  BulkUpdateFact = 'Bulk Updated Fact',
  BulkDeleteFacts = 'Bulk Delete Facts',
  SetKeyForFacts = 'Set Key For Facts',
  UpdateFactDate = 'Updated Fact Date',
  CommentAddedToFact = 'Comment Added To Fact',
  DeleteFact = 'Delete Fact',
  CopyFactId = 'Copy Fact ID',
  ToggleAllFactsOn = 'Toggle All Facts On',
  ToggleAllFactsOff = 'Toggle All Facts Off',
  SearchFacts = 'Search Facts',
  NaturalLanguageSearchFactsWand = 'Natural Language Search Facts Wand',
  NaturalLanguageSearchFactsSpacebar = 'Natural Language Search Facts Spacebar',
  ToggleKeyFacts = 'Toggle Key Facts',
  ToggleDisputedFacts = 'Toggle Disputed Facts',
  CreateFactFromFactsPage = 'Create Fact From Facts Page',
  CreateChronologyFromFactsPage = 'Create Chronology From Facts Page',
  AddToChronologyFromFactsPage = 'Add To Chronology From Facts Page',
  AddFact = 'Add Fact On Facts Page',
  FilterFactsByDate = 'Filter Facts By Date',
  FilterFactsByDocument = 'Filter Facts By Document',
  FilterFactsByRelevance = 'Filter Facts By Relevance',
  FilterFactsByClassification = 'Filter Facts By Classification',
  FilterFactsByProcessingRun = 'Filter Facts By Processing Run',
  FilterFactsByDocumentType = 'Filter Facts By Document Type',
  FilterFactsByTheme = 'Filter Facts By Theme',
  FilterFactsByPerson = 'Filter Facts By Person',

  // Persons/Entities
  FilterPersonByType = 'Filter Person By Type',
  ClickKeyEntityFromHome = 'Click Key Entity From Home',
  ClickEntitiesTab = 'Click Entities Tab',
  DownloadPersonsTableCSV = 'Download Persons Table CSV',
  DownloadPersonsTableDocx = 'Download Persons Table Docx',
  DownloadPersonsWrittenDocx = 'Download Persons Written Docx',

  // Visual Chronology
  AddVisualChronologyNode = 'Add Visual Chronology Node',
  EditVisualChronologyNode = 'Edit Visual Chronology Node',
  DeleteVisualChronologyNode = 'Delete Visual Chronology Node',
  ExportVisualChronology = 'Export Visual Chronology',
  SearchVisualChronology = 'Search Visual Chronology',
  OpenDocViewerFromVisualChronology = 'Open Doc Viewer From Visual Chronology',
  SaveVisualChronology = 'Save Visual Chronology',
  AddFactToChronologyOnVisualChronologyPage = 'Clicked to Add Fact From Table On Visual Chronology Page',
  ClickedToSwitchToVisualChronology = 'Clicked to Switch to Visual Chronology',

  // Inconsistencies page
  SearchInconsistencies = 'Search Inconsistencies',
  FilterInconsistenciesByDocument = 'Filter Inconsistencies By Document',
  FilterInconsistenciesBySeverity = 'Filter Inconsistencies By Severity',
  FilterInconsistenciesBySource = 'Filter Inconsistencies By Source',
  FilterInconsistenciesByType = 'Filter Inconsistencies By Type',
  CreateInconsistencyReport = 'Create Inconsistency Report',
  DownloadInconsistencyReport = 'Download Inconsistency Report',
  ViewInconsistencyReport = 'View Inconsistency Report',
  DeleteInconsistencyReport = 'Delete Inconsistency Report',

  // Client Materials
  CopyEmailTemplate = 'Copy Email Template',
  DownloadEmailTemplate = 'Download Email Template',
  DownloadOverviewDocument = 'Download Overview Document',
  DownloadCaseIssuesSheet = 'Download Case Issues Sheet',

  // Matter
  CreateMatter = 'Create Matter',
  SubmitMatter = 'Submit Matter',
  RemoveTeamMemberOnMatterCreator = 'Remove Team Member On Matter Creator',
  AddTeamMemberOnMatterCreator = 'Add Team Member On Matter Creator',
  ViewPersonalMatter = 'View Personal Matter',
  PersonalMatterUploadShortcut = 'Personal Matter Upload Shortcut',
  ViewMatter = 'View Matter',
  EditMatter = 'Edit Matter',

  // Onboarding
  OnboardingClickUploadDocuments = 'Onboarding Click Upload Documents',
  OnboardingClickCreateCase = 'Onboarding Click Create Case',
  OnboardingClickCreateMatter = 'Onboarding Click Create Matter',

  // Homepage
  ClickRecentCase = 'Click Recent Case',
  ViewHomepageGuide = 'View Homepage Guide',

  // Usage
  DownloadUsageData = 'Download Usage Data',

  // User Management
  AddUserToMatter = 'Add User To Matter',
  RemoveUserFromMatter = 'Remove User From Matter',

  // Transcription
  StartRecording = 'Start Recording',
  PauseRecording = 'Pause Recording',
  StopRecording = 'Stop Recording',
  ClickTranscriptInfoButton = 'Click Transcript Info Button',
  EditTranscriptBlockText = 'Edit Transcript Block Text',
  EditTranscriptBlockSpeaker = 'Edit Transcript Block Speaker',
  AssignSpeaker = 'Assign Speaker',
  ViewTranscriptSummary = 'View Transcript Summary',
  ClickTranscriptInconsistencySeeMore = 'Click Inconsistency See More',
  ClickTranscriptInconsistencyReference = 'Click Inconsistency Reference',
  ClickTranscriptInconsistencyReferenceBlock = 'Click Inconsistency Reference Block',
  ClickDiarizationCorrection = 'Click Diarization Correction',
  AcceptDiarizationCorrection = 'Accept Diarization Correction',
  RejectDiarizationCorrection = 'Reject Diarization Correction',
  ClickNewRecordingButton = 'Click New Recording Button',

  // Announcement Banner
  ClickAnnouncementBannerDismiss = 'Click Announcement Banner Dismiss',
  ClickAnnouncementBannerLink = 'Click Announcement Banner Link',
}

export enum PageName {
  CaseSummary = 'Case Summary',
  Kim = 'Kim',
  Facts = 'Facts',
  Chronology = 'Chronology',
  Inconsistencies = 'Inconsistencies',
  InconsistencyReport = 'Inconsistency Report',
  Entities = 'Entities',
  Documents = 'Documents',
  TranscriptList = 'Transcript List',
  Transcription = 'Transcription',
}
